import { render, staticRenderFns } from "./LatestSupplierMerchantContract.vue?vue&type=template&id=40cc5a4a&scoped=true&"
import script from "./LatestSupplierMerchantContract.vue?vue&type=script&lang=js&"
export * from "./LatestSupplierMerchantContract.vue?vue&type=script&lang=js&"
import style0 from "./LatestSupplierMerchantContract.vue?vue&type=style&index=0&id=40cc5a4a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40cc5a4a",
  null
  
)

export default component.exports